import { ChangeDetectionStrategy, Component, Input, OnDestroy, OnInit } from '@angular/core'
import { Title } from '@angular/platform-browser'
import { ActivatedRoute, Router } from '@angular/router'
import { Subscription } from 'rxjs'
import { BeatsSortBy } from '../../../enums/enums'
import { ILicense, ILicenseBulkDiscount } from '../../../Interface/license'
import { convertITrackToPlayerTrack, ITrack } from '../../../Interface/track'
import { PlayerLogic } from '../../../player/AngPlayer'
import { LicenseService } from '../../../services/license.service'
import { LicensesBulkDiscountService } from '../../../services/licenses-bulk-discount.service'
import { CurrencySignType, I18nService, LgType } from '../../../services/prod/i18n.service'
import { SsrService } from '../../../services/ssr.service'
import { TracksService } from '../../../services/tracks.service'
import { AppType } from '../../../types/app.type'

@Component({
  selector: 'bmcore-track-item-page',
  templateUrl: './bmcore-track-item-page.component.html',
  styleUrls: ['bmcore-track-item-page.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class BmcoreTrackItemPageComponent implements OnInit, OnDestroy {
  @Input() colorSettingsMode = false
  @Input() appType: AppType

  lg: LgType
  currencySign: CurrencySignType
  track: ITrack
  spotlightTracks: ITrack[] = []

  licenses: ILicense[] = []
  licenseBulkDiscounts: ILicenseBulkDiscount[] = []

  fullPageLoader = false

  private subscription: Subscription

  constructor(
    private tracksService: TracksService,
    private activateRoute: ActivatedRoute,
    private i18nService: I18nService,
    private player: PlayerLogic,
    private licenseService: LicenseService,
    private licensesBulkDiscountService: LicensesBulkDiscountService,
    private titleService: Title,
    private router: Router,
    private ssrService: SsrService
  ) {}

  ngOnInit() {
    this.fullPageLoader = true
    this.currencySign = this.i18nService.getCurrencySign()
    this.lg = this.i18nService.getLanguageForPage()
    this.reloadUrl()
    this.subscribeLicenseDiscounts()
  }

  reloadUrl() {
    /* Angular 2 reload url if query params change */
    // https://metanit.com/web/angular2/7.3.php
    this.subscription = this.activateRoute.params.subscribe(params => {
      const beatId = params['beatId']

      if (this.appType === 'BMSTV') {
        this.ssrService.wait('bmcore-track-item-page: tracksService.getCatalogBeatsForCurrentBeatmaker')
        this.ssrService.wait('bmcore-track-item-page: licensesBulkDiscountService.licenseDiscountSubject')
        this.ssrService.wait('bmcore-track-item-page: licenseService.getLicensesByBeat')
      }

      this.getTrack(Number(beatId))
      this.getLicensesByBeat(Number(beatId))
    })
  }

  getTrack(beatId: number) {
    this.tracksService.getBeatById(beatId).subscribe(
      res => {
        this.track = res
        this.setDocumentTitle(this.track.name, this.track.beatmakerName)

        this.getCatalogBeats(this.track.beatmakerId)
        this.licensesBulkDiscountService.getLicensesDiscount(this.track.beatmakerId)
      },
      () => {
        this.appType === 'BMSTV' && this.router.navigate(['/404'])
      }
    )
  }

  getCatalogBeats(beatmakerId: number) {
    this.tracksService.getCatalogBeatsForCurrentBeatmaker(beatmakerId, BeatsSortBy.ChartTop, 1, 6).subscribe(res => {
      this.ssrService.ready('bmcore-track-item-page: tracksService.getCatalogBeatsForCurrentBeatmaker')
      this.spotlightTracks = res.items
      this.fullPageLoader = false
    })
  }

  getLicensesByBeat(beatId: number) {
    this.licenseService.getLicensesByBeat(beatId).subscribe(res => {
      this.licenses = res.items
      this.ssrService.ready('bmcore-track-item-page: licenseService.getLicensesByBeat')
    })
  }

  subscribeLicenseDiscounts() {
    this.licensesBulkDiscountService.licenseDiscountSubject.subscribe(res => {
      this.licenseBulkDiscounts = res
      this.ssrService.ready('bmcore-track-item-page: licensesBulkDiscountService.licenseDiscountSubject')
    })
  }

  setPlaylist() {
    this.player.setPlayList(this.spotlightTracks.map(convertITrackToPlayerTrack))
  }

  setDocumentTitle(trackTitle: string, beatmakerName: string) {
    this.titleService.setTitle(`${trackTitle} by ${beatmakerName} | beatmakers.tv`)
  }

  checkIsBMSTV() {
    return this.appType === 'BMSTV'
  }

  ngOnDestroy() {
    this.subscription.unsubscribe()
  }
}
